import { render, staticRenderFns } from "./homebottom8.vue?vue&type=template&id=43070793&scoped=true"
import script from "./homebottom8.vue?vue&type=script&lang=js"
export * from "./homebottom8.vue?vue&type=script&lang=js"
import style0 from "./homebottom8.vue?vue&type=style&index=0&id=43070793&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43070793",
  null
  
)

export default component.exports